"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedLabel = void 0;
const useLabelState_1 = require("./useLabelState");
const useToolsStateSelector_1 = require("./useToolsStateSelector");
function useSelectedLabel() {
    const labels = (0, useLabelState_1.useLabelState)();
    const selectedID = (0, useToolsStateSelector_1.useToolsStateSelector)(state => { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.labelsState) === null || _a === void 0 ? void 0 : _a.selectedLabelID) || null; });
    return labels.find(label => label.identifier === selectedID);
}
exports.useSelectedLabel = useSelectedLabel;
